// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__27yKF","modalFooterButton":"ModalNotes_modalFooterButton__2iDdG"};